import { render, staticRenderFns } from "./FormValidationEvents.vue?vue&type=template&id=60b50077&"
import script from "./FormValidationEvents.vue?vue&type=script&lang=js&"
export * from "./FormValidationEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports